import OpticksLogo from "@/components/ui/OpticksLogos/OpticksLogo";

const EmailVerificationPending = () => (
  <>
    <OpticksLogo />
    <h2>Your login needs to be validated</h2>
    <p>
      We detected that the current IP you are using is not recognized and must
      be validated before accepting your attempt to log in.
    </p>
    <p>
      The account administrators have been notified and they will grant you
      access soon.
    </p>
  </>
);

export default EmailVerificationPending;
